import { NgxSliderModule } from "@angular-slider/ngx-slider";
import { TextFieldModule } from "@angular/cdk/text-field";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { MaskitoDirective } from '@maskito/angular';
import { CurrencyMaskModule } from "ng2-currency-mask";
import { NgxFloatUiModule } from "ngx-float-ui";
import { DirectivesModule } from "src/app/directives/directives.module";
import { AddressSelectorModule } from "../address-selector/address-selector.module";
import { SharedModule } from "../shared/shared.module";
import { QuestionComponent } from "./question/question.component";
import { AddressSelectorQuestionComponent } from "./types/address-selector-question/address-selector-question.component";
import { ButtonSelectQuestionComponent } from "./types/button-select-question/button-select-question.component";
import { ChildrenQuestionComponent } from "./types/children-question/children-question.component";
import { ConfirmQuestionComponent } from "./types/confirm-question/confirm-question.component";
import { DateQuestionComponent } from "./types/date-question/date-question.component";
import { DayOfMonthQuestionComponent } from "./types/day-of-month-question/day-of-month-question.component";
import { DisplayComponent } from "./types/display/display.component";
import { EmailQuestionComponent } from "./types/email-question/email-question.component";
import { ImageSelectQuestionComponent } from "./types/image-select-question/image-select-question.component";
import { NumericQuestionComponent } from "./types/numeric-question/numeric-question.component";
import { SelectDateQuestionComponent } from "./types/select-date-question/select-date-question.component";
import { SelectQuestionComponent } from "./types/select-question/select-question.component";
import { SliderQuestionComponent } from "./types/slider-question/slider-question.component";
import { TelNoQuestionComponent } from "./types/tel-no-question/tel-no-question.component";
import { TextQuestionComponent } from "./types/text-question/text-question.component";
import { TimeQuestionComponent } from "./types/time-question/time-question.component";

const questionTypes = [
  EmailQuestionComponent,
  ImageSelectQuestionComponent,
  EmailQuestionComponent,
  TextQuestionComponent,
  DateQuestionComponent,
  TelNoQuestionComponent,
  SliderQuestionComponent,
  ButtonSelectQuestionComponent,
  ChildrenQuestionComponent,
  SelectQuestionComponent,
  DayOfMonthQuestionComponent,
  TimeQuestionComponent,
  AddressSelectorQuestionComponent,
  NumericQuestionComponent,
  SelectDateQuestionComponent,
  ConfirmQuestionComponent,
  DisplayComponent
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TextFieldModule,
    DirectivesModule,
    NgxSliderModule,
    NgxFloatUiModule,
    CurrencyMaskModule,
    SharedModule,
    AddressSelectorModule,

    MaskitoDirective
  ],
  providers: [],
  exports: [
    QuestionComponent,

    ...questionTypes
  ],
  declarations: [
    QuestionComponent,

    ...questionTypes
  ]
})
export class QuestionsModule { }
